import { Table } from 'redesign';
import { useMemo } from 'react';
import { WorkersPoolItem } from 'ogp/services/workers-pool-service.types';
import { ExternalFlexPoolsTableColumnDefinition } from './helpers/external-flex-pools-table.types';
import { useExternalFlexPoolsColumnDefinition } from './helpers/use-external-flex-pools-column-definition';
import { getExternalFlexPoolsTableData } from './helpers/get-external-flex-pools-table-data';

type Props = {
  data: WorkersPoolItem[];
  onRowClick?: (row: ExternalFlexPoolsTableColumnDefinition) => void;
};

export const ExternalFlexPoolsTable = ({ data, onRowClick }: Props) => {
  const columns = useExternalFlexPoolsColumnDefinition();
  const tableData = useMemo(() => getExternalFlexPoolsTableData(data), [data]);

  return (
    <Table<ExternalFlexPoolsTableColumnDefinition>
      columns={columns}
      data={tableData}
      onRowClick={onRowClick}
    />
  );
};
